import { Box, Typography } from '@mui/material';
import { ArrowCircleUpIcon } from '../../Dashboard/Styles/arrows';
import { EMPTY_PLACEHOLDER } from '../wingmanIntelligenceMetrics';

const METRIC_COLOR = '#34a853';

/**
 * Performance trend tile — Dashboard green palette; value + body bottom-aligned.
 */
const PerformanceTrendCard = ({ title, displayValue, countLine }) => {
  const body2Text = countLine ? `${countLine} in selected period` : EMPTY_PLACEHOLDER;

  return (
    <Box
      sx={{
        p: 1.5,
        height: '100%',
        minHeight: 140,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Typography variant="subtitle1" component="h2" sx={{ fontWeight: 'medium', mb: 1 }}>
        {title}
      </Typography>

      <Box
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-end',
        }}
      >
        <Typography variant="h4" component="span" sx={{ color: METRIC_COLOR }}>
          {displayValue}
        </Typography>

        <Typography
          variant="body2"
          sx={{ color: METRIC_COLOR, display: 'flex', alignItems: 'center', mt: 0.5 }}
        >
          {countLine && <ArrowCircleUpIcon sx={{ fontSize: 20, mr: 0.5 }} />}
          {body2Text}
        </Typography>
      </Box>
    </Box>
  );
};

export default PerformanceTrendCard;
